var React = require('react');

function IconYouTube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.101.303C10.718.14 5.41.141 3.03.303.454.479.15 2.035.131 6.132c.019 4.09.32 5.653 2.9 5.829a104.21 104.21 0 0 0 10.071 0c2.577-.176 2.88-1.732 2.899-5.829-.019-4.09-.32-5.653-2.899-5.829zM6.082 8.777v-5.29l5.29 2.64-5.29 2.65z"}));
}

IconYouTube.defaultProps = {"width":"16","height":"13","fill":"#fff"};

module.exports = IconYouTube;

IconYouTube.default = IconYouTube;
